import { FileText } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionDescriptionFilterConfig(): FilterStringConfig {
  return {
    label: 'Description',
    icon: <FileText />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' })
  };
}
